
enum language {
  language_english = 'English',
  language_chinese = 'Chinese',
  language_spanish = 'Spanish',
  language_hindi = 'Hindi'
}
enum language_english {
  Sign_In = 'Sign In',
  Existing_Patient = 'Existing Patient',
  New_Patient = 'New Patient',
  Name = 'Name',
  Date_of_Birth = 'Date of Birth',
  Enter_Name = 'Enter your name',
  Write_Name = 'Please write your name in the box below',
  Write_DOB = 'Please write your dob as MM/DD/YYYY in the box below',
  Enter_Date_Of_Birth = 'Enter Date Of Birth',
  Done = 'Done',
  Please_have_a_seat = 'You have successfully signed In \n\n Please have a seat',
  Save = 'Save',
  Cancel = 'Cancel',
  Clear = 'Clear',
  Use_keyboard = 'Click here to use keyboard',
  Use_pad = 'Click here to use signature pad'
}

enum language_chinese {
  Sign_In = '请登记',
  Existing_Patient = '现有患者',
  New_Patient = '新病人',
  Name = '姓名',
  Date_of_Birth = '出生日期',
  Enter_Name = '点击使用键盘',
  Write_Name = '填写姓名',
  Enter_Date_Of_Birth = '输入出生日期',
  Done = '完成',
  Please_have_a_seat = '成功登记 请坐稍候',
  Save = '保存',
  Cancel = '取消',
  Clear = '取消',
  Use_keyboard = '点击这里使用键盘',
  Use_pad = '点击这里使用签名板'
}

enum language_spanish {
  Sign_In = 'Registrarse',
  Existing_Patient = 'Paciente existente',
  New_Patient = 'Paciente nuevo',
  Name = 'Nombre',
  Date_of_Birth = 'Fecha de nacimiento',
  Enter_Name = 'Introduzca su nombre',
  Write_Name = 'Escribe tu nombre',
  Enter_Date_Of_Birth = 'Ingrese fecha de nacimiento',
  Done = 'Hecho',
  Please_have_a_seat = 'Por favor tome asiento',
  Save = 'Salvar',
  Cancel = 'Cancelar',
  Clear = 'clara',
  Use_keyboard = 'Haga clic aquí para usar el teclado',
  Use_pad = 'Haga clic aquí para usar el panel de firma'
}

enum language_hindi {
  Sign_In = 'आगमन',
  Existing_Patient = 'मौजूदा रोगी',
  New_Patient = 'नया रोगी',
  Name = 'नाम',
  Date_of_Birth = 'जन्म की तारीख',
  Enter_Name = 'नाम दर्ज करें',
  Write_Name = 'अपना नाम लिखो',
  Enter_Date_Of_Birth = 'जन्म् की तारीख़ दर्ज करे',
  Done = 'समाप्त',
  Please_have_a_seat = 'कृपया विराजमान होएं',
  Save = 'जमा करें',
  Cancel = 'रद्द करना',
  Clear = 'हटाना',
  Use_keyboard = 'कीबोर्ड का उपयोग करने के लिए यहां क्लिक करें',
  Use_pad = 'हस्ताक्षर पैड का उपयोग करने के लिए यहां क्लिक करें'
}

export class AppEnum {
  public Entitylanguage: typeof language = language;
  public English: typeof language_english = language_english;
  public Chinese: typeof language_chinese = language_chinese;
  public Spanish: typeof language_spanish = language_spanish;
  public Hindi: typeof language_hindi = language_hindi;
}



